import env from '../../../../env';
import { AppClientId } from "../../../Shared/constants";
import { VehicleCreateStep1Default } from "./Step1Base/installations/Step1BaseDefault";
import { VehicleCreateStep1Indewal } from "./Step1Base/installations/Step1BaseIndewal";
import { VehicleCreateStep1Nijboer } from "./Step1Base/installations/Step1BaseNijboer";
import { VehicleCreateStepHooikammer } from "./Step1Base/installations/Step1BaseHooikammer";
import { VehicleCreateStep1IDWGMBH } from "./Step1Base/installations/Step1BaseIDWGMBH";
import { VehicleCreateStep1Wientjes } from "./Step1Base/installations/Step1BaseWientjes";
import { VehicleCreateStep1Autohuissalland } from "./Step1Base/installations/Step1BaseAutohuissalland";
import { VehicleCreateStepHiltermann } from './Step1Base/installations/Step1BaseHiltermann';


let component = VehicleCreateStep1Default;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    component = VehicleCreateStep1Indewal;
    break;
    case AppClientId.IDWLEASE:
      component = VehicleCreateStep1Indewal;
      break;
  case AppClientId.HARRY_NIJBOER:
    component = VehicleCreateStep1Nijboer;
    break;
  case AppClientId.HOOIKAMMER:
    component = VehicleCreateStepHooikammer;
    break;
  case AppClientId.IDW_GMBH:
    component = VehicleCreateStep1IDWGMBH;
    break;
  case AppClientId.AUTOWIENTJES:
    component = VehicleCreateStep1Wientjes;
    break;
  case AppClientId.AUTOHUISSALLAND:
      component = VehicleCreateStep1Autohuissalland;
      break;
      case AppClientId.HILTERMANN:
        component = VehicleCreateStepHiltermann;
        break;
}

export const VehicleCreateStep1 = component;
